(function ($) {
    $(function () {

        if ($('.js-calendar-wrapper').length) {

            var year = $('.template-calendar').data("year")

            var today_timestamp = new Date((new Date().toISOString().slice(0, 10))).getTime() / 1000;
            var start_date = new Date((new Date(year + '-12-01').toISOString().slice(0, 10))).getTime() / 1000;
            if (window.location.hostname == "tvpaprika.donebox.hu") {
                start_date = new Date((new Date(year + '-11-01').toISOString().slice(0, 10))).getTime() / 1000;
            }

            if (window.location.hostname != "advent.tvpaprika.hu" && window.location.hostname != "adventnikalendar.tvpaprika.cz" && window.location.hostname != "calendaruldeadvent.tvpaprika.ro") {
                $('footer,header,.js-search-overlay,.mobil-menu,.shape-overlays').removeClass('hide')
            }

            var frontpage_calendar = Cookies.get('frontpage_calendar');

            if (start_date > today_timestamp) {
                $('.modal__calendar').remove();
                if ($('body').hasClass('page-template-template-calendar') || $('body').hasClass('page-template-template-calendar-2021')) {
                    window.location = localize.siteurl;
                }
            } else {
                if ($('#modal__calendar').length) {
                    if (start_date <= today_timestamp) {
                        $('#modal__calendar').iziModal({
                            title: localize.translations.advent,
                            appendTo: '.modal__calendar',
                            borderBottom: false,
                            fullscreen: false,
                            openFullscreen: true,
                            autoOpen: (frontpage_calendar == undefined) ? '1000' : 0
                        });

                        Cookies.set('frontpage_calendar', 1, { expires: 1 });
                    }
                }

                var current_opened_days = Cookies.get('opened_days');

                if (current_opened_days != undefined) {
                    current_opened_days = current_opened_days.split(',');
                    $.each(current_opened_days, function (index, val) {
                        $(`.js-calendar-item[data-date='${val}']`).addClass('active');
                    });
                }



                $('.js-calendar-item').each(function (i, e) {
                    var current_timestamp = $(this).data('date');


                    if (current_timestamp > today_timestamp) {
                        $(this).find('.js-play-video').remove();
                        $(this).removeClass('js-calendar-item-hoverable')
                    }

                });


                $('.js-calendar-wrapper').imagesLoaded(function () {
                    $('.js-calendar-wrapper').fadeTo("400", 1, function (e) {
                        var $today_item = $(`.js-calendar-item[data-date='${today_timestamp}']`);
                        if (!$today_item.hasClass('active')) {
                            $today_item.addClass('today');
                        }
                    });
                });

                $(".js-calendar-item-hoverable").hover(function () {
                    $(this).removeClass('today');

                    $(this).addClass('flip');
                },
                    function () {
                        $(this).removeClass('flip');
                    });

                $('#modal__video').iziModal({
                    width: $('.container').width(),
                    appendTo: '.modal__video',
                    appendToOverlay: '.modal__video',
                });


                $('.js-play-video').on('click', function (e) {
                    e.preventDefault();
                    var $video_id = $(this).data('video');
                    var $recept_link = $(this).data('url');
                    if ($video_id.length) {
                        $('#modal__video .iziModal-content').html(`<iframe src="https://www.youtube-nocookie.com/embed/${$video_id}?autoplay=1&amp;rel=0&amp;enablejsapi=1" frameborder="0" allow="autoplay" allowfullscreen="1"></iframe>`).after(`${($recept_link != "") ? `<div class="modal__button_wrapper"><a href="${$recept_link}" class="button button--primary">
                        ${localize.translations.advent_recipe_button}</a></div>` : ""}`).promise().done(function () {
                            $('#modal__video').iziModal('open');
                        });
                    }



                    var $parent = $(this).parents('.js-calendar-item');
                    $parent.addClass('active');
                    var $day_value = ($parent.data('date')).toString();
                    var opened_days = Cookies.get('opened_days');
                    var $watched_items = [];
                    if (opened_days != undefined) {
                        $watched_items = opened_days.split(',');
                    }

                    if ($watched_items.indexOf($day_value) === -1) {
                        $watched_items.push($day_value);
                    }

                    Cookies.set('opened_days', $watched_items.join(','), { expires: 365 });

                });

                $(document).on('closing', '#modal__video', function (e) {
                    $('#modal__video .iziModal-content').empty();
                    $('#modal__video .modal__button_wrapper').remove();
                });
            }



        }

    });
})(jQuery);